export const TEST_EMAIL = 'user@mail.com';
export const FAIL_EMAIL = 'fail@mail.com';
export const TEST_PASSWORD = 'Password1';
export const FAIL_PASSWORD = 'FailureWord1';
export const RECAPTCHA_DEV = '6LfcvR0bAAAAALeCZHjnJHEA7lq0-6O4lbAR1oI4-111';
export const RECAPTCHA_DEV_SCORE =
  '6LeKCvMbAAAAAJkjyTZysO31ze1l-cStmW6ll0Gy-222';
export const WEB_VIEW_PARAM = 'webview';
export const PAGE_TYPE = 'login';
export const SIGN_IN_TYPE = 'External sign in checkout';
